import DateRangeSelect from "@entrilia/shared/components/DateRangeSelect";
import type { DescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import {
  anytime,
  last30Days,
  lastMonth,
  lastQuarter,
  lastSevenDays,
  lastYear,
  thisMonth,
  thisQuarter,
  thisYear,
  today,
} from "@entrilia/shared/utilities/dateFilterHelper";
import useInboxStateContext from "../../../../../contexts/useInboxStateContext";

const filterDateItems = [
  anytime,
  today,
  lastSevenDays,
  last30Days,
  thisMonth,
  thisQuarter,
  thisYear,
  lastMonth,
  lastQuarter,
  lastYear,
];

interface Props {
  fullWidth?: boolean;
}

const FilterDate = ({ fullWidth }: Props) => {
  const { updateCriteria, criteria } = useInboxStateContext();

  const onDateSelected = (descriptiveDate: DescriptiveDateRange) => {
    updateCriteria({
      from: descriptiveDate.from?.toISOString(),
      to: descriptiveDate.to?.toISOString(),
      descriptiveDate: descriptiveDate,
      page: 0,
    });
  };

  return (
    <DateRangeSelect
      dateRange={criteria.descriptiveDate}
      predefinedRanges={filterDateItems}
      onChange={onDateSelected}
      fullWidth={fullWidth}
    />
  );
};

export default FilterDate;
